// ============================================================
// Format-Helfer (Zahlen, Datum, Zeit, Währung)
// ============================================================

export const MON = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
export const WD = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

const nf2 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const nf0 = new Intl.NumberFormat('de-DE');

export function eur(n: number): string {
  return nf2.format(n || 0) + ' €';
}

export function sEur(n: number): string {
  const v = n || 0;
  const sign = v > 0 ? '+' : v < 0 ? '−' : '';
  return sign + nf2.format(Math.abs(v)) + ' €';
}

export function pct(n: number | null, d = 1): string {
  if (n == null || !isFinite(n)) return '–';
  return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d }) + ' %';
}

export function sPct(n: number): string {
  const sign = n > 0 ? '+' : n < 0 ? '−' : '';
  return sign + Math.abs(n).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %';
}

export function dstr(iso: string): string {
  const d = new Date(iso);
  return (
    String(d.getDate()).padStart(2, '0') +
    '.' +
    String(d.getMonth() + 1).padStart(2, '0') +
    '.' +
    d.getFullYear()
  );
}

export function tstr(iso: string): string {
  const d = new Date(iso);
  return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
}

export function isoDay(d: Date): string {
  return (
    d.getFullYear() +
    '-' +
    String(d.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(d.getDate()).padStart(2, '0')
  );
}

export function fmtNum(n: number): string {
  return nf0.format(n);
}

// Fixierter NOW-Zeitpunkt — entspricht dem Stand des exportierten
// Datensatzes. Wird für rollierende Zeiträume verwendet.
export const NOW = new Date('2026-07-16T23:59:59');
